import { inject, Service } from "@angular/core";

import { AiAgent, AiAgentLink } from "../models/ai-agent-model";
import { MainResponseModel } from "../models/main-response-model";
import { MainService } from "./main-service";

@Service()
export class AiAgentsApiService {
  private readonly _apiPrefix = "ai-agent";
  private readonly _mainService = inject(MainService);

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<AiAgent>>({
      method: "GET",
      url: `${this._apiPrefix}/getById?id=${id}`,
    });
  }

  public save(agent: AiAgent, isEdit: boolean) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${this._apiPrefix}/${isEdit ? "update" : "create"}`,
      data: agent,
    });
  }

  public deleteById(id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `${this._apiPrefix}/delete?id=${id}`,
    });
  }

  public changeStatus(id: number, isActive: boolean) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${this._apiPrefix}/changeStatus`,
      data: { id, isActive },
    });
  }

  public getSelectableAgents() {
    return this._mainService.sendRequest<MainResponseModel<AiAgentLink[]>>({
      method: "GET",
      url: `${this._apiPrefix}/getSelectableAgents`,
    });
  }
}
